import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgJhipsterModule } from 'ng-jhipster';
import { QuillModule } from 'ngx-quill';

@NgModule({
    imports: [
        NgbModule.forRoot(),
        NgJhipsterModule.forRoot({
            // HACK: Changing the config here won't have any effect
            // unless it also changed in shared-common.module.ts.
            // I don't know why.
            i18nEnabled: true,
            defaultI18nLang: 'fr',
        }),
    ],
    exports: [
        FormsModule,
        HttpClientModule,
        CommonModule,
        NgbModule,
        NgJhipsterModule,
        QuillModule,
    ],
})
export class PlatonSharedLibsModule {}



// WEBPACK FOOTER //
// ./src/app/shared/shared-libs.module.ts